import APIUrl from "../../APIUrl";
import axios from "axios";
import Util from "../../util/Util";

export const LOGOUT = "LOGOUT";
export const GET_URL = "GET_URL";

function getLogoutAction() {
  return { type: LOGOUT };
}

export const logout = function (successCallback) {
  return function (dispatch) {
    // Save logout URL BEFORE clearing sessionStorage
    // (logoutRedirect is stored in sessionStorage and would be lost)
    var logoutUrl = Util.getLogoutUrl();

    // Delete tokens
    axios.defaults.headers.common["jwtToken"] = null;

    delete axios.defaults.headers.jwtToken;
    delete axios.defaults.headers.common["jwtToken"];
    delete APIUrl.jwtToken;

    // Clear session storage
    sessionStorage.clear();

    dispatch(getLogoutAction());
    successCallback(logoutUrl);
  };
};
